import { render, staticRenderFns } from "./MskuGenerationTable.vue?vue&type=template&id=4a8ab6a5&scoped=true"
import script from "./MskuGenerationTable.vue?vue&type=script&lang=js"
export * from "./MskuGenerationTable.vue?vue&type=script&lang=js"
import style0 from "./MskuGenerationTable.vue?vue&type=style&index=0&id=4a8ab6a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ab6a5",
  null
  
)

export default component.exports